var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQtproject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1.13274 0 0 1.14985 -19.481 18.15)",
    gradientUnits: "userSpaceOnUse",
    x1: 14.556,
    x2: 0.333,
    y1: 16.333,
    y2: 5.667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#197cf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20bcfa"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -2.994,
    x2: -41.26,
    y1: 36.934,
    y2: -1.905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34495e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c7865"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "translate(1.01 -1.022)",
    gradientUnits: "userSpaceOnUse",
    x1: -14.65,
    x2: -6.43,
    y1: 9.178,
    y2: 17.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "translate(0 -1.022)",
    gradientUnits: "userSpaceOnUse",
    x1: -28.756,
    x2: -10.858,
    xlinkHref: "#c",
    y1: 9.268,
    y2: 27.436
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: -42.27,
    x2: -4.004,
    y1: -1.905,
    y2: 36.934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66b036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239161"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99317 0 0 .97839 45.973 4.864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-36.03-.883c-2.894 0-5.137 2.332-5.223 5.224v33.615h33.04c2.894 0 5.223-2.331 5.223-5.224v-33.615z",
    fill: "url(#e)",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 1.014
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-29.17 6.271-3.02 4.088 2.458 17.375 3.02 2.044-1.074 2.044 4.332 4.398 13.01-1.912c.487-.085.946-.297 1.363-.603l-5.54-8.686.794-9.199-9.06-9.199z",
    fill: "url(#d)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-12.06 7.293-3.02 20.442 6.751 6.853c1.063-.939 2.311-3.634 2.311-5.304v-15.858z",
    fill: "url(#c)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-27.16 5.249c-4.03 0-7.05 2.044-7.05 11.754 0 8.01 2.149 10.798 5.086 11.53.524 6.17 6.997 4.312 6.997 4.312v-2.044s-2.611.88-2.975-2.29c2.888-.769 4.989-3.586 4.989-11.508 0-9.71-3.02-11.754-7.05-11.754m0 2.044c2.01 0 3.02 1.689 3.02 9.71 0 8.02-1.01 9.71-3.02 9.71s-3.02-1.689-3.02-9.71c0-8.02 1.01-9.71 3.02-9.71",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.994 31.71c0 2.894-2.329 5.224-5.223 5.224h-33.04v1.022h33.04c2.894 0 5.223-2.331 5.223-5.224z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-15.08 7.293h3.02v4.088h2.01v2.044h-2.01v11.243c0 2.044 2.01.511 2.01.511v2.044s-6.04 3.577-6.04-2.555v-11.243h-1.01v-2.044h1.01z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 1.014
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.495 21.603-13.584 13.789h-.004v4.608h4.54v-.005l13.584-13.789-.002-.002.002-.002-4.531-4.599-.002.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.495 21.603-13.584 13.789h-.004v4.608h4.54v-.005l13.584-13.789-.002-.002.002-.002-4.531-4.599-.002.002zm-2.263 3.923 2.934 2.978-8.595 8.725v-1.828h-2.265v-1.828zm-9.06 9.197v1.828h2.265v1.828l-.465.472h-1.801l-1.133-1.15v-1.828z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.246 25.419-13.259 13.465h-4.071v1.116h4.541v-.004l13.583-13.79-.002-.002.002-.002z",
    fill: "#0c69cf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQtproject);
export default __webpack_public_path__ + "static/media/qtproject.6ddd081d357600f8a8a15b4ff6161618.svg";
export { ForwardRef as ReactComponent };